// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Jsg2","footer":"Form_footer__1hk34"};